<div class="modal-header">
  <h4 class="modal-title promo-modal-title" id="promo-modal-title">{{ isNew ? 'Add Promotion' : 'Edit Promotion' }}</h4>
  <span class="promo-modal-status" [ngClass]="'is-' + promo?.status">{{ statusLabel }}</span>
  <button type="button" class="btn-close" aria-label="Close" title="Close Modal" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="formGroup">
    <div class="data-showcase-grid">
      <p class="promo-status-hint">{{ statusHint }}</p>

      <div class="row promo-field-grid">
        <div class="col-sm-4">
          <app-input [inputType]="'text'" [fieldText]="'Badge'" [fControl]="formGroup.controls['Badge']"
                     [inputClass]="'form-control'" [inputPlaceholder]="'e.g. Now Pouring'" [inputLabel]="'Badge'"
                     [labelClass]="'data-label'" [isRequired]="false"
                     (keydown.enter)="$event.preventDefault()"></app-input>
        </div>
        <div class="col-sm-8">
          <app-input [inputType]="'text'" [fieldText]="'Title'" [fControl]="formGroup.controls['Title']"
                     [inputClass]="'form-control'" [inputPlaceholder]="'e.g. Happy Hour'" [inputLabel]="'Title'"
                     [labelClass]="'data-label'" (keydown.enter)="$event.preventDefault()"></app-input>
        </div>
        <div class="col-sm-6">
          <app-input [inputType]="'text'" [fieldText]="'When'" [fControl]="formGroup.controls['When']"
                     [inputClass]="'form-control'" [inputPlaceholder]="'e.g. Mon–Fri · 2–4pm'" [inputLabel]="'When'"
                     [labelClass]="'data-label'" [isRequired]="false"
                     (keydown.enter)="$event.preventDefault()"></app-input>
        </div>
        <div class="col-sm-6">
          <app-input [inputType]="'text'" [fieldText]="'Lead'" [fControl]="formGroup.controls['Lead']"
                     [inputClass]="'form-control'" [inputPlaceholder]="'One-line summary'" [inputLabel]="'Lead'"
                     [labelClass]="'data-label'" [isRequired]="false"
                     (keydown.enter)="$event.preventDefault()"></app-input>
        </div>
        <div class="col-12">
          <label class="data-label" for="promoBody">Body</label>
          <textarea id="promoBody" class="form-control textarea-cnt" formControlName="Body"
                    placeholder="Describe the promotion your customers will see"></textarea>
        </div>

        <!-- Image + 3 device crops -->
        <div class="col-12">
          <label class="data-label">Promotion Image</label>
          <p *ngIf="imageLoadFailed && !imageSource" role="alert">The photo could not be loaded.</p>

          <div class="file-upload-wrap promo-upload" *ngIf="!imageSource">
            <input type="file" #promoFile accept="image/*,.heic,.heif" [disabled]="isCompressing" (change)="onImageSelected($event)"
                   (click)="promoFile.value = ''" />
            <div class="upload-inner">
              <img src="./assets/images/ic-add.svg" alt="Add Icon" class="add-icon" (click)="promoFile.click()" />
              <!-- Large photos take a moment to shrink before the cropper can open. -->
              <span>{{ isCompressing ? 'PREPARING PHOTO…' : 'ADD PHOTO' }}</span>
            </div>
          </div>

          <!-- Cropper above, tab strip below it — the order ImageConfigurationComponent uses. -->
          <div class="promo-crop-block" *ngIf="imageSource">
            <p class="promo-crop-hint">
              Move and resize the crop box to choose what each device frame shows. Each frame is
              saved independently.
            </p>

            <!-- Shared editor: cropper above, frame tabs beneath, image actions projected onto
                 the tab row. Same component the landing background uses. -->
            <app-mini-menu-crop-editor *ngIf="isImageReady" [imageSource]="imageSource"
                                       [frames]="frames" [crops]="crops"
                                       (readyChange)="onCropReady($event)" (loadError)="imageLoadFailed = true"
                                       (cropsChange)="onCropsChange($event)">
              <div class="promo-crop-links">
                <button type="button" class="promo-crop-link" title="Replace the promotion image" [disabled]="isCompressing"
                        (click)="promoReplace.click()">Replace</button>
                <button type="button" class="promo-crop-link is-destructive" title="Remove the promotion image" [disabled]="isCompressing"
                        (click)="removeImage()">Remove</button>
                <input type="file" #promoReplace accept="image/*,.heic,.heif" hidden [disabled]="isCompressing" (change)="onImageSelected($event)"
                       (click)="promoReplace.value = ''" />
              </div>
            </app-mini-menu-crop-editor>
          </div>
        </div>
      </div>

      <!-- Canonical HUNGERY action stack (skip-login-modal): filled primary on top, lighter
           text button beneath. .project-modal .btn-grps is already a column. -->
      <div class="btn-grps promo-modal-actions">
        <app-button [btnText]="'Save'" [btnTitle]="'Save'" [btnCss]="'btn btn-primary w-100 btn-lg'"
                    [isDisable]="isCompressing || imageLoadFailed || (!!imageSource && !isCropReady)" (onBtnClick)="save()"></app-button>
        <app-button [btnText]="'Cancel'" [btnTitle]="'Cancel'" [btnCss]="'btn btn-text w-100 btn-md'"
                    (onBtnClick)="cancel()"></app-button>
      </div>
    </div>
  </form>
</div>
